<template>
  <BContainer :title="$t('title.reportHistorical')">
    <ReportFilter
      @apply="loadChartData"
      :options="{ visibility: { answerSetId: false, answerSetGroupId: false } }"
      v-if="!role.limited"
    ></ReportFilter>
    <section
      class="section has-background-light"
      style="padding-top:15px; margin-top:15px;"
      v-if="chartData && !role.limited"
    >
      <div v-if="isGroup">
        <div class="columns is-multiline  is-centered">
          <div
            class="column is-6"
            v-for="(historicalDataItem, index) in chartData.historicalScoreData"
            :key="index"
          >
            <article class="message is-light">
              <div class="message-header ">
                <div class="title is-size-5 has-text-centered" style="width: 100%;">
                  {{ historicalDataItem.process.name }} Puan Gelişimi
                </div>
              </div>
              <div class="message-body">
                <BarChartForPoint
                  :name="`${historicalDataItem.process.id}`"
                  :data="historicalDataItem.scores"
                  :labels="historicalDataItem.labels"
                ></BarChartForPoint>
              </div>
            </article>
          </div>
          <div
            :class="`column ${chartData.historicalScoreData.length % 2 === 0 ? 'is-6' : 'is-6'}`"
          >
            <article class="message is-light">
              <div class="message-header ">
                <div class="title is-size-5 has-text-centered" style="width: 100%;">
                  {{ chartData.final.processGroup.name }} Ağırlıklı Puan Gelişimi
                </div>
              </div>
              <div class="message-body">
                <BarChartForPoint
                  :name="'final'"
                  :data="chartData.final.scores"
                  :labels="chartData.final.labels"
                ></BarChartForPoint>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="column is-size-4 has-text-centered">{{ $t('title.netaScore') }}</div>
        <div class="columns is-centered">
          <div class="column is-4">
            <BarChart
              :name="'final'"
              :data="chartData.final"
              :title="$t('title.final')"
              :labels="labels"
            ></BarChart>
          </div>
        </div>
        <div class="column is-size-4 has-text-centered">
          {{ $t('title.internalControlQualificationLevels') }}
        </div>
        <div class="columns is-centered is-multiline">
          <div class="column is-4">
            <BarChart
              :name="'financialReport'"
              :data="chartData.financialReport"
              :title="$t('title.financialReport')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4">
            <BarChart
              :name="'adaptation'"
              :data="chartData.adaptation"
              :title="$t('title.adaptation')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4">
            <BarChart
              :name="'operation'"
              :data="chartData.operation"
              :title="$t('title.operation')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4">
            <BarChart
              :name="'abuse'"
              :data="chartData.abuse"
              :title="$t('title.abuse')"
              :labels="labels"
            ></BarChart>
          </div>
        </div>
        <div class="column is-size-4 has-text-centered">
          {{ $t('title.internalControlComponentQualificationLevels') }}
        </div>
        <div class="columns is-centered is-multiline">
          <div class="column is-4" v-if="chartData.controlEnvironment != null">
            <BarChart
              :name="'controlEnvironment'"
              :data="chartData.controlEnvironment"
              :title="$t('title.controlEnvironment')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4" v-if="chartData.riskAssessment != null">
            <BarChart
              :name="'riskAssessment'"
              :data="chartData.riskAssessment"
              :title="$t('title.riskAssessment')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4" v-if="chartData.controlActivities != null">
            <BarChart
              :name="'controlActivities'"
              :data="chartData.controlActivities"
              :title="$t('title.controlActivities')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4" v-if="chartData.informationCommunication != null">
            <BarChart
              :name="'informationCommunication'"
              :data="chartData.informationCommunication"
              :title="$t('title.informationCommunication')"
              :labels="labels"
            ></BarChart>
          </div>
          <div class="column is-4" v-if="chartData.monitoring != null">
            <BarChart
              :name="'monitoring'"
              :data="chartData.monitoring"
              :title="$t('title.monitoring')"
              :labels="labels"
            ></BarChart>
          </div>
        </div>
      </div>
    </section>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import helpers from '../../_helpers/vue.helper'
import { BarChart, BarChartForPoint } from '../../components'
import ApiService from '../../_api/api.service'
import ReportFilter from './ReportFilter.vue'
import format from 'date-fns/format'

export default {
  components: {
    ReportFilter,
    BarChart,
    BarChartForPoint
  },
  data () {
    return {
      labels: [],
      chartData: null,
      isGroup: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  mounted () {
    if (this.role.limited) {
      helpers.showLimitedUserAlert(this)
      // this.$buefy.dialog.confirm({
      //   message: this.$t('description.processLimitedUserAlert'),
      //   confirmText: this.$t('button.goToPaidMembership'),
      //   cancelText: this.$t('button.later'),
      //   onConfirm: () => {
      //     this.goToPayment();
      //   },
      // });
    } else {
      this.getProceses()
    }
  },
  methods: {
    goToPayment () {
      this.$router.push({ name: 'payment' })
    },
    getProceses () {
      ApiService.query('/process').then(data => {
        this.processes = data
      })
    },
    loadChartData (params) {
      const { filter, isGroup } = params
      this.labels = []
      this.chartData = null
      this.isGroup = isGroup
      if (isGroup) {
        ApiService.get(
          `/answerset/group/score/historical?processGroupId=${filter.processGroupId}&userId=${filter.userId}`
        ).then(data => {
          this.chartData = {
            final: {
              processGroup: data[0].answerSetGroup.processGroup,
              scores: data.map(x => x.finalScore),
              labels: data.map(x =>
                x.answerSetGroup.submitDate
                  ? format(new Date(x.answerSetGroup.submitDate), 'dd-MM-yy')
                  : ''
              )
            },
            historicalScoreData: []
          }
          for (let i = 0; i < data.length; i++) {
            const scoreGroup = data[i]
            for (let index = 0; index < scoreGroup.scores.length; index++) {
              const scoreData = scoreGroup.scores[index]
              if (this.chartData.historicalScoreData.length < index + 1) {
                this.chartData.historicalScoreData.push({
                  process: scoreData.answerSet.process,
                  scores: [],
                  labels: []
                })
              }
              this.chartData.historicalScoreData[index].scores.push(scoreData.finalScore)
              this.chartData.historicalScoreData[index].labels.push(
                scoreData.answerSet.submitDate
                  ? format(new Date(scoreData.answerSet.submitDate), 'dd-MM-yy')
                  : ''
              )
            }
          }
        })
      } else {
        ApiService.get(
          `/answerset/score/historical?processId=${filter.processId}&userId=${filter.userId}`
        ).then(data => {
          if (data && data.length > 0) {
            this.chartData = {
              final: [],
              financialReport: [],
              adaptation: [],
              operation: [],
              abuse: [],
              controlEnvironment: [],
              riskAssessment: [],
              controlActivities: [],
              informationCommunication: [],
              monitoring: []
            }
            const emptyDataCount = 4 - data.length
            for (let index = 0; index < emptyDataCount; index++) {
              const element = { score: null, answerSet: { submitDate: '' } }
              data.push(element)
            }
            data.forEach(score => {
              this.labels.push(
                score.answerSet.submitDate && score.answerSet.submitDate !== ''
                  ? format(new Date(score.answerSet.submitDate), 'dd-MM-yy')
                  : ''
              )
              this.chartData.final.push(score.finalScore / 100)
              this.chartData.financialReport.push(score.financialReportFinal)
              this.chartData.adaptation.push(score.adaptationFinal)
              this.chartData.operation.push(score.operationFinal)
              this.chartData.abuse.push(score.abuseFinal)
              this.chartData.controlEnvironment.push(score.controlEnvironmentScore)
              this.chartData.riskAssessment.push(score.riskAssessmentScore)
              this.chartData.controlActivities.push(score.controlActivitiesScore)
              this.chartData.informationCommunication.push(score.informationCommunicationScore)
              this.chartData.monitoring.push(score.monitoringScore)
            })
          }
        })
      }
    },
    getDate (date) {
      return date
    },
    skip () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
